import { FactoryTemplate } from "components/templates"

const Factory = (): JSX.Element => {
  return <FactoryTemplate />
}

export default Factory
